import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Button from "../components/Button";
import styles from "./CustomerSelectModal.module.css";
import { useState, useEffect } from "react";
import Customer from "../components/Customer";

function CustomerSelectModal({ switchCustomer }) {
  const [customers, setCustomers] = useState([]);
  const [editModal, setEditModal] = useState({ show: false, props: null });
  const [isOpen, setIsOpen] = useState(false);

  const searchParameters = {
    fname: "",
    lname: "",
    ph: "",
    em: "",
    comp: "",
  };

  const [searchParams, setSearchParams] = useState(searchParameters);

  const openModal = () => {
    setIsOpen((x) => !x);
  };
  const closeModal = () => {
    setIsOpen((x) => !x);
    setSearchParams(searchParameters);
  };

  useEffect(() => {
    try {
      getCustomers();
    } catch (error) {}
  }, [searchParams]);

  const clearSearch = async (el) => {
    const theTarget = document.getElementById(el);
    switch (el) {
      case "name":
        await setSearchParams({ ...searchParams, fname: "", lname: "" });
        break;
      case "phone":
        await setSearchParams({ ...searchParams, ph: "" });
        break;
      case "email":
        await setSearchParams({ ...searchParams, em: "" });
        break;
      case "company":
        await setSearchParams({ ...searchParams, comp: "" });
        break;
    }
    theTarget.value = "";
    theTarget.nextSibling.classList.remove(styles.show);
  };

  const getCustomers = async () => {
    //const searchtext = document.getElementById("name").value;
    //const textSplit = searchtext.split(" ");
    let fname = searchParams.fname;
    let lname = searchParams.lname;
    let ph = searchParams.ph;
    let em = searchParams.em;
    let comp = searchParams.comp;
    const res = await fetch(`/api/customers?f=${fname}&l=${lname}&t=${ph}&e=${em}&c=${comp}&limit=100`);
    const data = await res.json();
    setCustomers(data);
  };

  const editCustomer = async (customer) => {
    setEditModal({ show: true, props: customer });
  };

  const handleSearchChange = async (e) => {
    let theInput;
    if (e.target) {
      theInput = e.target;
    } else {
      theInput = e;
    }
    const siblingSpan = theInput.nextSibling;

    if (theInput.value.length > 0) {
      siblingSpan.classList.add(styles.show);
    } else {
      siblingSpan.classList.remove(styles.show);
    }

    const textSplit = e.target.value.split(" ");

    switch (e.target.name) {
      case "name":
        await setSearchParams({ ...searchParams, fname: textSplit[0], lname: textSplit[1] ? textSplit[1] : "" });
        break;
      case "phone":
        await setSearchParams({ ...searchParams, ph: e.target.value });
        break;
      case "email":
        await setSearchParams({ ...searchParams, em: e.target.value });
        break;
      case "company":
        await setSearchParams({ ...searchParams, comp: e.target.value });
        break;
    }
  };

  return (
    <>
      <Button type="pOutline" onClick={openModal}>
        Change Customer
      </Button>
      {isOpen && (
        <div className={styles.modalBackdrop} id="CustomerSelectModal">
          <div className={`${styles.modalTop}`}>
            <div className={`${styles.modalBody}`}>
              <h3 className={styles.modalHeader}>Change Customers</h3>
              <div>
                <table className={styles.customerSelectTable}>
                  <thead>
                    <tr>
                      <th>
                        <input type="text" name="name" id="name" placeholder="Name" onChange={handleSearchChange} />
                        <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("name")}></span>
                      </th>
                      <th>
                        <input type="text" name="company" id="company" placeholder="Company" onChange={handleSearchChange} />
                        <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("company")}></span>
                      </th>
                      <th>
                        <input type="text" name="phone" id="phone" placeholder="Phone" onChange={handleSearchChange} />
                        <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("phone")}></span>
                      </th>
                      <th>
                        <input type="text" name="email" id="email" placeholder="Email" onChange={handleSearchChange} />
                        <span className={`fa-solid fa-circle-xmark ${styles.clearButton}`} onClick={() => clearSearch("email")}></span>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(customers) &&
                      customers.map((cust) => {
                        return (
                          <tr>
                            <td>
                              {cust.FirstName} {cust.LastName}
                            </td>
                            <td>{cust.CompanyName}</td>
                            <td>{cust.Phone}</td>
                            <td>{cust.Email}</td>
                            <td>
                              <Button
                                type="primary"
                                onClick={() => {
                                  closeModal();
                                  switchCustomer(cust);
                                }}
                              >
                                Switch
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className={styles.formSelectButtons}>
              <Button type="save" onClick={closeModal}>
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CustomerSelectModal;
